class EventData {
  #data = {};

  set(data) {
    this.#data = data;
  }

  // Method to get a value from the private object
  get() {
    return this.#data;
  }
}

export const eventData = new EventData();